
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IBankruptcyResult } from 'src/app/search/models';

@Component({
  selector: 'app-bankruptcy-score',
  imports: [CommonModule, TranslateModule],
  templateUrl: './bankruptcy-score.component.html',
  styleUrls: ['./bankruptcy-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankruptcyScoreComponent {

  @Input()
  score: IBankruptcyResult

}
